import { render, staticRenderFns } from "./BrandExplanation.vue?vue&type=template&id=3998d032"
import script from "./BrandExplanation.vue?vue&type=script&lang=js"
export * from "./BrandExplanation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports